module.exports = __webpack_public_path__ + "467d881b21906e6631fb1a27e621cd30.png";